// extracted by mini-css-extract-plugin
export default {"toggle":"LanguageSwitcher_toggle__tH62N","dark":"LanguageSwitcher_dark__FLmRe","light":"LanguageSwitcher_light__NCrks"};